/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedItemTrackingProvider_viewer = {
    readonly regionalInfo?: ReadonlyArray<{
        readonly regionsByZipCode: ReadonlyArray<{
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "BuySharedItemTrackingProvider_viewer";
};
export type BuySharedItemTrackingProvider_viewer$data = BuySharedItemTrackingProvider_viewer;
export type BuySharedItemTrackingProvider_viewer$key = {
    readonly " $data"?: BuySharedItemTrackingProvider_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedItemTrackingProvider_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedItemTrackingProvider_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userZipCode",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchRegionalInfo",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "regionalInfo",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "userZipCode"
            }
          ],
          "concreteType": "RegionalInfo",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "regionsByZipCode",
              "storageKey": null,
              "args": null,
              "concreteType": "RegionsByZipCode",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "displayName",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '324f999c98740d882623732f518d1593';
export default node;
